export default {
      id: "sw_facebook-usage",
      viewBox: "0 0 22 22",
      url: "../dist/images/" + "sprite.svg#sw_facebook-usage",
      toString: function () {
        return this.url;
      }
    }